<script setup lang="ts">
// Copied from layers/tairo-layout-sidebar/components/TairoSidebarBurger.vue
// and modified to fix dark mode colors

const { isOpen, toggle } = useSidebar()
</script>

<template>
  <button
    type="button"
    class="flex size-10 items-center justify-center"
    @click="toggle"
  >
    <div class="relative size-5" :class="isOpen ? 'scale-90' : ''">
      <span
        class="bg-primary-500 dark:bg-muted-100 absolute block h-0.5 w-full transition-all duration-300"
        :class="
          isOpen ? 'top-1 max-w-[75%] -rotate-45 rtl:rotate-45' : 'top-0.5'
        "
      />
      <span
        class="bg-primary-500 dark:bg-muted-100 absolute top-1/2 block h-0.5 w-full max-w-[50%] transition-all duration-300"
        :class="isOpen ? 'translate-x-4 opacity-0 rtl:-translate-x-4' : ''"
      />
      <span
        class="bg-primary-500 dark:bg-muted-100 absolute block h-0.5 w-full transition-all duration-300"
        :class="
          isOpen ? 'bottom-1 max-w-[75%] rotate-45 rtl:-rotate-45' : 'bottom-0'
        "
      />
    </div>
  </button>
</template>
